import { render, staticRenderFns } from "./Product-WLZG.vue?vue&type=template&id=fbb9ef56&scoped=true"
import script from "./Product-WLZG.vue?vue&type=script&lang=js"
export * from "./Product-WLZG.vue?vue&type=script&lang=js"
import style0 from "./Product-WLZG.vue?vue&type=style&index=0&id=fbb9ef56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb9ef56",
  null
  
)

export default component.exports